<script>
// 动态表单模版
import Temp from '@/components/technician/temp/index'
import sendEmail from '@/components/technician/sendEmail/index'
import {
  changeManageExport,
  process_flowClassifiedQuery,
  processTaskHistorical,
  processUploadFiles,
  processUserRelevanceCompleteList
} from "@/lib/request";
import {getLocalItem} from "@/untils/common";
import {ClientId} from "@/lib/cli";
import {ImagePreview} from "vant";

export default {
  name: 'techHistory',
  data() {
    return {
      downObj:{},
      flagEmail:false,
      searchText:'',
      dateFlag:true,
      statueFlag:false,
      itemStatue:0,
      statueTitle:'待领取',
      dataStatue:[
        {type:'0',title:'待领取'},
        {type:'1',title:'未完成'},
      ],
      typeFlag:false,
      itemType:0,
      typeTitle:'全部',
      typeState:'',
      dataType:[
        {type:'',title:'全部'},
        {type:'1',title:'新装机'},
        {type:'2',title:'撤机'},
        {type:'3',title:'移机'},
        {type:'4',title:'信息更正'},
        {type:'5',title:'经营类型变更'},
        {type:'6',title:'网点录入'},
        {type:'7',title:'特殊巡检'},
        {type:'8',title:'巡检'},
      ],
      // 动态表单模版
      returnObj:{},
      formDefine:{},
      flowNameObj:{},
      formFields:[],
      flagTemp:false,
      activeTab: '',//'西藏-网点维护',
      // 列表数据
      page1:1,//当前页
      size1:20,//每页条数
      totals1:0,//总条数
      totalPages1:0,//总页数
      finished1: true,
      loading1:false,
      finishedMsgTxt:'没有更多了',
      inList:[],
      // 流程历史信息
      historyList:[],
      uploadFlag:false,
      uploadList:[],
      uploadObjList:{},
      //------
      fileVideoUrl:'/api/resource/oss/upload',//接口前缀加api
      headers:{
        'isEncrypt':true,
        'Authorization': 'Bearer ' + getLocalItem('access_token'),
        'clientid' : ClientId,
      },
      loading:false,
      flagButton:false,
      // imgFlag2: false,
      //是否显示进度条
      // imgUploadPercent2: 0,
      //进度条的进度，
      // isShowUploadImg2: false,
      //显示上传按钮
      // imgForm2: {
      //   showVideoPath: "",  //回显的变量
      // },
      nickName:'',
      page_data: 0,//当前页
      size_data: 10,//每页条数
      totals_data: 0,//总条数
      totalPages_data: 0,//总页数
      finished_data: true,
      loading_data: false,
      finishedMsgTxt_data: '没有更多了',
      inList_data: []
    }
  },
  components:{
    Temp,sendEmail
  },
  watch:{
    // 监控参数变化更新游戏列表接口数据
    searchParams:function(newVal,oldVal) {
      if(newVal.category!==oldVal.category){
        this.page1 = 1;
      }
      // this.getListData();
    },
    paramsSearch(newVal, oldVal) {
      if (newVal.state !== oldVal.state) {
        this.page_data = 0;
      }
      this.getFlowClassifiedQuery();
    },
  },
  computed:{
    // 监控参数变化更新游戏列表接口数据
    searchParams() {
      return {
        pageSize:this.size1,//每页数量
        pageNum:this.page1,//当前页码
        category:this.activeTab,
        // openId:this.user_openid,//
        // orderByColumn:'createTime',
        // isAsc:'asc',
        // state:this.activeTab//积分类型
      };
    },
    paramsSearch() {
      return {
        size: this.size_data,//每页数量
        page: this.page_data,//当前页码
        search: this.searchText,//身份证号、网点编号、手机号
        flowType:this.typeState,//flowType(1、新装机，2、撤机、3、移机，4、信息更正，5、经营类型变更，6、网点录入、7、特殊巡检，8、巡检)不填写查所有
        // orderByColumn:'createTime',
        sort:this.dateFlag?'DESC':'ASC',// sort（“ASC”，“DESC”）不填写默认asc上，DESC下
        state:'1',//this.activeTab //（0、待领取，1、已完成，2、未完成）
      };
    },
  },
  created() {
    // 当前任务列表数据
    // this.getListData();
    this.getFlowClassifiedQuery();
    this.nickName = getLocalItem('nickName');
  },
  methods: {

    hide(){
      this.statueFlag = false;
      this.typeFlag = false;
    },
    getSwitchDate(){
      this.page_data = 0;
      this.dateFlag = !this.dateFlag;
    },
    getSwitchType(){
      this.typeFlag = !this.typeFlag;
      if(this.statueFlag){
        this.statueFlag = false;
      }
    },
    getTypeCurrent(index,item){
      this.itemType = index;
      this.typeTitle = item.title;
      this.typeState = item.type;
      this.typeFlag = !this.typeFlag
    },
    getCameraDown(){
      this.$router.push({path:'/crame'});
    },
    getLoadDown(item){
      changeManageExport({
        id:item,
        pageNum:1,
        pageSize:10
      }).then((res)=>{
        if(res){
          try {
            const blob = new Blob([res.data]);
            const src = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = src;
            a.download = `${new Date().getTime()}` + `.docx`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(src);
            console.log('文件下载已开始');
          } catch (error) {
            console.log(`下载失败: ${error.message}`);
          }
          // // -----
          // const blob = new Blob([res.data]);
          // const src = URL.createObjectURL(blob);
          // const a = document.createElement('a');
          // a.style.display = 'none';
          // a.href = src;
          // a.download = `${new Date().getTime()}` + `.docx`;
          // document.body.appendChild(a);
          // a.click();
          // document.body.removeChild(a);
          // window.URL.revokeObjectURL(src);
          // // ------
          // // console.log('11112222333')
          // // console.log(res)
          // // console.log(res.data)
          // // let blobs  = new Blob([res.data])
          // // console.log(blobs)
          // //创建一个a标签
          // const link = document.createElement('a');
          // //实例化一个blob出来
          // const blob = new Blob([res.data]);
          // link.style.display = 'none';
          // //将后端返回的数据通过blob转换为一个地址
          // link.href = URL.createObjectURL(blob);
          // // 设置属性和下载下来后文件的名字以及后缀名,名字和后缀名也可设置为传过来的变量
          // link.setAttribute(
          //     'download',
          //     `统计数据_${new Date().getTime()}` + `.docx`);
          // // 插入元素
          // document.body.appendChild(link);
          // //下载该文件
          // link.click();
          // //移除元素
          // document.body.removeChild(link);
        }
      });
    },
    getDownLoad(item){
      this.downObj = item;
      this.flagEmail = true;
    },
    getLoad(item){
      console.log(item)
      this.uploadObjList = item;
      if(item.uploadFiles){
        this.uploadFlag = true;
        item.uploadFiles.map((v)=>{
          if(v.state){
            if(v.value){
              v.files = [{
                url:v.value
              }];
            }
          }else{
            v.files = [];
          }
        });
        this.uploadList = item.uploadFiles;
        const emptyField = this.uploadObjList.uploadFiles.find(item => !item.value);
        this.flagButton = emptyField!==undefined;
      }
    },
    getClose() {
      if(this.uploadObjList.uploadFiles&&this.uploadObjList.uploadFiles.length>0){
        const emptyField = this.uploadObjList.uploadFiles.find(item => !item.state);
        if(emptyField){
          this.$toast(`请上传资料并提交！`);
          return false;
        }
        this.uploadFlag = false;
        // this.getListData();
        this.getFlowClassifiedQuery();
      }
    },
    // 图片放大
    showPreview(index, item) {
      let arr = [];
      item.map((v)=>{
        if(v.response){
          arr.push(v.response.data.url)
        }else{
          arr.push(v.url)
        }
      });
      ImagePreview({
        images: arr,
        startPosition: index,
        closeable: true,
      });
    },
    // -------------
    beforeUploadImg1(file) {
      if (
          ["image/png","image/jpg", "image/jpeg",].indexOf(file.type) === -1     //控制格式
      ) {
        this.$toast("请上传正确的图片格式");
        return false;
      }
      let fileSize = file.size / 1024 / 1024 < 500;   //控制大小  修改50的值即可
      if (!fileSize) {
        this.$toast("图片大小不能超过500MB");
        return false;
      }
      this.isShowUploadImg1 = false;
      // this.imgForm2.showVideoPath = URL.createObjectURL(file);
    },
    handleSuccess(response, file, fileList, index) {
      console.log(response, file, fileList, index)
      this.loading = true;
      this.isShowUploadImg1 = true;
      this.imgFlag1 = false;
      this.imgUploadPercent1 = 0;
      //后台上传数据
      if (response.code === 200) {
        if(response.data){
          this.loading = false;
          let arr = [];
          fileList.map((v)=>{
            if(v.response){
              arr.push(v.response.data.url)
            }
          });
          this.uploadList[index].files = fileList;
          this.uploadList[index].value = arr.join(',');
        }
      } else {
        this.$toast(response.msg);
        return false;
      }
    },
    handleExceed(files, fileList) {
      console.log(files, fileList)
      this.$toast(`最多只能上传 1 张图片`);
    },
    handleRemove(file, fileList, index) {
      console.log(file, fileList, index)
      let arr = []
      fileList.map((v)=>{
        if(v.response){
          arr.push(v.response.data.url);
        }
      });
      this.uploadList[index].files = fileList;
      this.uploadList[index].value = arr.join(',');
    },

    getUploadImg(item,index){
      if(!this.uploadList[index].value){
        this.$toast(`请上传 ${item.name} 资料`);
        return false;
      }
      let params = {
        processInstanceName:this.uploadObjList.flowname,
        processInstanceId:this.uploadObjList.processid,
        name:item.name,
        value:this.uploadList[index].value
      }
      processUploadFiles(params).then((res)=>{
        if(res){
          if(!res.data){
            return;
          }
          if(res.data.code===200){
            this.$toast('提交成功');
            this.uploadList[index].state = true;

          }else{
            this.$toast(res.msg);
            return false;
          }
        }
      });
    },
    onLoad() {
      setTimeout(() => {
        if(this.page1<this.totalPages1){
          this.page1 = this.page1+1;
        }
      },1000);
    },
    onLoad_data() {
      setTimeout(() => {
        if (this.page_data < this.totalPages_data) {
          this.page_data = this.page_data + 1;
        }
      }, 1000);
    },
    // 当前任务列表数据
    getListData(){
      this.loading1 = true;
      this.finished1 = false;
      if(this.searchParams.pageNum===1){
        this.inList = []
      }
      processUserRelevanceCompleteList(this.searchParams).then((res)=>{
        if(res){
          if(res.data){
            this.loading1 = false;
            if(res.data.code===200){
              let resData = res.data.data.taskQueryOutputList;
              this.totals1 = res.data.data.totalCount;
              this.totalPages1 = Math.ceil(res.data.data.totalCount / this.size1);
              if (resData == null || resData.length === 0) {
                this.finished1 = true;
                this.inList = [];
                return false;
              } else {
                resData.map((v)=>{
                  if(v.uploadFiles&&v.uploadFiles.length>0){
                    v.lookBtn = false;
                    const items = v.uploadFiles.find(item => !item.value);
                    if(items){
                      v.lookBtn = true;
                    }
                  }
                  if(v.processInstanceName){
                    if(v.processInstanceName.split('-')&&v.processInstanceName.split('-').length>1){
                      v.arr_name = v.processInstanceName.split('-')[1];
                    }else{
                      v.arr_name = v.processInstanceName;
                    }
                  }else if(v.processDefinitionName){
                    if(v.processDefinitionName.split('-')&&v.processDefinitionName.split('-').length>1){
                      v.arr_name = v.processDefinitionName.split('-')[1];
                    }else{
                      v.arr_name = v.processDefinitionName;
                    }
                  }
                });
                if (this.page1 > 1) {
                  this.inList = this.inList.concat(resData);
                } else {
                  this.inList = resData;
                }
                // 总条数和每页条数
                if (this.totals1 < this.size1) {
                  this.finished1 = true;
                  return;
                }
                // 当前页和总页数
                if (this.page1 === this.totalPages1) {
                  this.finished1 = true;
                  return false;
                }
              }
            }else{
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    },
    getFlowClassifiedQuery(){
      this.loading_data = true;
      this.finished_data = false;
      if (this.paramsSearch.page === 0) {
        this.inList_data = [];
      }
      process_flowClassifiedQuery(this.paramsSearch).then((response)=>{
        let res = response.data;
        if(res){
          this.loading_data = false;
          if(res.code===200){
            if(res.data){
              let resData = res.data.formResultBeanList;
              this.totals_data = res.data.total;
              this.totalPages_data = Math.ceil(res.data.total / this.size_data) - 1;
              if (resData == null || resData.length === 0) {
                this.finished_data = true;
                this.inList_data = [];
                return false;
              } else {
                if(resData&&resData.length>0){
                  resData.map((v)=>{
                    v.processInstanceId = v.processid
                    v.taskId = v.taskid
                    v.endTime = v.endtime;
                    if(v.uploadFiles&&v.uploadFiles.length>0){
                      v.lookBtn = false;
                      const items = v.uploadFiles.find(item => !item.value);
                      if(items){
                        v.lookBtn = true;
                      }
                    }
                  })
                }
                if (this.page_data > 0) {
                  this.inList_data = this.inList_data.concat(resData);
                } else {
                  this.inList_data = resData;
                }
                // 总条数和每页条数
                if (this.totals_data < this.size_data) {
                  this.finished_data = true;
                  return;
                }
                // 当前页和总页数
                if (this.page_data === this.totalPages_data) {
                  this.finished_data = true;
                  return false;
                }
              }
            }
          } else {
            this.$toast.fail(res.msg);
          }
        }
      })
    },
    // 查看网点
    getQuerySiteIdInfo(siteId){
      if(siteId){
        this.$router.push({path:'/techSiteId',query:{'siteId':siteId}});
      }else{
        this.$toast('无网点编号');
      }
    },
    // 任务详情
    getHistoryObjectData(processInstanceId){
      if(!processInstanceId){
        return
      }
      // this.$router.push({path:'/temp',query:{'processInstanceId':processInstanceId}});
      processTaskHistorical({
        processInstanceId:processInstanceId,
        handler:false
      }).then((res)=> {
        if (res) {
          if (res.data) {
            if (res.data.code === 200) {
              if(res.data.data.historicActivityInstances&&res.data.data.historicActivityInstances.length>0){
                res.data.data.historicActivityInstances.map((v)=>{
                  if(v.formInfo.fields){
                    v.formInfo.fields.map((i)=>{
                      if(i.params.customDesign.type==='fileupload'){
                        i.files = i.value?i.value.split(','):[];
                      }else if(i.params.customDesign.type==='rate'){
                        i.value = parseInt(i.value)/2;
                      }
                    })
                  }
                });
                this.historyList = res.data.data.historicActivityInstances;
                this.flagTemp = true;
              }else{
                this.historyList = [];
              }
            }else{
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    },

    // 流程表单提交接口
    getTempReturn(data){
      console.log(data)
      this.formFields = [];
      this.returnObj = {};
      this.formDefine = {};
      this.flagTemp = false;
      // this.getListData();
      this.getFlowClassifiedQuery();
    },
    getEmailReturn(data){
      console.log('data',data)
    }
  }
}
</script>
<template>
  <div class="tech-content" @click="hide">
    <!-- 动态表单模版-->
    <Temp v-model="flagTemp" content="close" :variablesObj="{}" :historyList="historyList" :flowNameObj="flowNameObj" :siteIdObj="{}" :returnObj="returnObj" :formDefine="formDefine" :formFields="formFields" @submit="getTempReturn"></Temp>
    <!-- 下载文件到邮箱 -->
    <sendEmail v-model="flagEmail" :variablesEmailObj="downObj" @submit="getEmailReturn"></sendEmail>
    <!--上传图片弹窗-->
    <van-popup
        v-model="uploadFlag"
        round
        :close-on-click-overlay="false"
        position="bottom"
    >
      <div class="" >
        <div class="form-section">
          <div class="supply-item">
            <div class="supply-header">
              <div class="supply-name">{{uploadObjList.arr_name}}</div>
              <div class="supply-btn" @click="uploadFlag=false"><van-icon name="cross" /></div>
            </div>
            <div class="quantity-section">
              <div class="warehouse-label"><span></span>资料上传</div>
              <div class="warehouse-section" v-for="(v,k) in uploadList" :key="k">
                <div class="warehouse-clo">
                  <div class="warehouse-label-tit">{{ v.name }}</div>
                  <div class="group-video">
                    <div class="group-video-load" >
                      <el-upload
                          v-if="!v.state"
                          class="avatar-uploader"
                          :action="fileVideoUrl"
                          :headers="headers"
                          :limit="1"
                          multiple
                          :file-list="v.files"
                          accept="image/jpeg, image/jpg, image/png"
                          list-type="picture-card"
                          :on-exceed="handleExceed"
                          :on-success="(response, file, fileList) => handleSuccess(response, file, fileList, k)"
                          :before-upload="beforeUploadImg1"
                          :on-remove="(file, fileList) => handleRemove(file, fileList, k)">
                        <i class="el-icon-plus"></i>
                      </el-upload>

                      <van-image
                          v-else
                          v-for="(val,kes) in v.files" :key="kes"
                          :src="val.url"
                          @click="showPreview(kes,v.files)"
                      /></div>
                  </div>
                  <div class="sub-btn" v-if="!v.state"><div class="clo-btn" @click="getUploadImg(v,k)">提交</div></div>
                </div>
              </div>
              <div class="form-buttons-btm" v-if="flagButton">
                <van-button block plain type="primary" @click="getClose">确定</van-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <div class="tabs" style="flex-direction: column">
      <van-field v-model="searchText" type="number" left-icon="search" placeholder="搜索网点编号/手机号" />
      <div class="tabs-select" @click.stop>
        <!--      <div class="tabs-flex">-->
        <!--        <div class="flex-title" @click="getSwitchStatue">{{statueTitle}}<van-icon name="arrow-down" color="#aaa" /></div>-->
        <!--        <div class="flex-data" v-show="statueFlag">-->
        <!--          <div class="flex-data-item" v-for="(item,index) in dataStatue" :class="itemStatue===index?'current':''" :key="index" @click="getCurrent(index,item)">{{item.title}}<van-icon v-if="itemStatue===index" name="success" color="#aaa" /></div>-->
        <!--        </div>-->
        <!--      </div>-->
        <div class="tabs-flex">
          <div class="flex-title" @click="getSwitchType">{{typeTitle}}<van-icon name="arrow-down" color="#aaa" /></div>
          <div class="flex-data" v-show="typeFlag">
            <div class="flex-data-item" v-for="(item,index) in dataType" :class="itemType===index?'current':''" :key="index" @click="getTypeCurrent(index,item)">{{item.title}}<van-icon v-if="itemType===index" name="success" color="#aaa" /></div>
          </div>
        </div>
        <div class="tabs-flex-text">
          <span class="rotate" @click="getSwitchDate">
            {{dateFlag?'时间倒序':'时间正序'}}<van-icon v-if="dateFlag" name="down" /><van-icon class="up-to-date" v-if="!dateFlag" name="down" />
          </span>
        </div>
      </div>
    </div>
    <div style="padding-bottom: 20px">
      <!--    <van-list v-model="loading1" :finished="finished1" :finished-text="finishedMsgTxt" :immediate-check="false" @load="onLoad">-->
      <!--      <div class="card" v-for="(item,index) in inList" :key="index">-->
      <!--        <div class="card-title">-->
      <!--          {{item.arr_name}}-->
      <!--          <div v-if="item.uploadFiles&&item.uploadFiles.length>0">-->
      <!--            <span class="upload-btn" v-if="item.lookBtn" @click="getLoad(item)">上传</span>-->
      <!--            <span class="upload-btn bog" v-else @click="getLoad(item)">查看</span>-->
      <!--          </div>-->
      <!--        </div>-->

      <!--        <div class="card-info">-->
      <!--          <div class="card-info-item">流程进度：{{item.name}}</div>-->
      <!--        </div>-->
      <!--        <div class="card-info">-->
      <!--          <div class="card-info-item">网点编号：{{ item.variables.siteid }}</div>-->
      <!--          <div class="card-info-item">地区：{{item.variables.city}}</div>-->
      <!--        </div>-->
      <!--        <div class="card-info">-->
      <!--          <div class="card-info-item" v-if="item.variables&&item.variables.name">联系人：{{item.variables.name}}</div>-->
      <!--          <div class="card-info-item" v-if="item.variables&&item.variables.phone">联系电话：{{item.variables.phone}}</div>-->
      <!--        </div>-->
      <!--        <div class="card-footer">-->
      <!--          <div>完成时间：{{item.endTime}}</div>-->
      <!--          <div>-->
      <!--            <button class="btns btn-secondary" v-show="item.siteid" @click="getQuerySiteIdInfo(item.siteid)">查看网点</button>-->
      <!--            <button class="btns btn-secondary" @click="getHistoryObjectData(item.processInstanceId)">任务详情</button>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--    </van-list>-->
      <van-list v-model="loading_data" :finished="finished_data" :finished-text="finishedMsgTxt_data" :immediate-check="false" @load="onLoad_data">
        <div class="card" v-for="(item,index) in inList_data" :key="index">
          <div class="card-title">
            {{item.flowname}}
            <div>
              <span class="upload-btn mr" v-if="item.fileName&&item.fileName.length>0" @click="getDownLoad(item)">下载</span>
              <span class="upload-btn" v-if="item.lookBtn&&(item.uploadFiles&&item.uploadFiles.length>0)" @click="getLoad(item)">上传</span>
              <span class="upload-btn bog" v-else @click="getLoad(item)">查看</span>
            </div>
          </div>
          <div class="card-info">
            <div class="card-info-item">流程进度：{{item.currentnodename}}</div>
          </div>
          <div class="card-info">
            <div class="card-info-item">网点编号：{{ item.siteid }}</div>
            <div class="card-info-item">地区：{{item.city}}</div>
          </div>
          <div class="card-info">
            <div class="card-info-item" v-if="item.name">联系人：{{item.name}}</div>
            <div class="card-info-item" v-if="item.phone">联系电话：{{item.phone}}</div>
          </div>
          <div class="card-footer">
            <div class="time-size">完成时间：{{item.endTime}}</div>
            <div>
              <button class="btns btn-secondary" v-show="item.siteid" @click="getQuerySiteIdInfo(item.siteid)">查看网点</button>
              <button class="btns btn-secondary" @click="getHistoryObjectData(item.processInstanceId)">任务详情</button>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<style scoped lang="scss">
.tech-content{
  padding-top: 120px;
  box-sizing: border-box;
}

.tabs{
  overflow: inherit;
  padding:20px 15px 15px;
}
.tabs-select{
  display: flex;
  flex-direction: row;
  align-items: center;
  //justify-content:space-between;
  padding-top: 20px;
}
.van-cell{
  height: 70px;
  background: #f3f3f5;
  border-radius: 10px;
  padding-top: 10px;
  padding-left: 10px;
}
.tabs-flex-text{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 60%;
  font-size: 20px;
}
.tabs-flex{
  display: flex;
  padding:0 10px 10px 0;
  position: relative;
  width: 40%;
  .flex-title{
    display: flex;
    background: #f3f3f5;
    border-radius: 10px;
    padding:0 15px;
    height: 70px;
    width: 100%;
    font-size: 26px;
    align-items: center;
    justify-content: space-between;
  }
  .flex-data{
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 0;
    top: 80px;
    height: auto;
    width: 94%;
    margin: 0 1px;
    padding:10px 12px;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    .flex-data-item{
      padding: 10px;
      border-radius: 10px;
      display: flex;
      font-size: 26px;
      align-items: center;
      justify-content: space-between;
    }
    .current{
      background: #f3f3f5;
    }
  }
}
.up-to-date{
  transform: rotate(180deg);
}
.rotate{
  color: #aaa;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 25px;
}
/deep/.van-sticky--fixed{
  z-index: 9 !important;
}
.upload-btn-load{
  background: #2196f3;
  padding: 8px 20px;
  color: #fff;
  font-size: 24px;
  border-radius: 6px;
  margin-right: 8px;
}
.upload-btn{
  background: #e62d2d;
  padding: 8px 20px;
  color: #fff;
  font-size: 24px;
  border-radius: 6px;
}
.bog{
  background: #f5f5f5;
  border: 2px solid #ddd;
  color: #666;
}
.mr{
  background: #1989fa;
  border: 2px solid #1989fa;
  margin-right: 10px;
  color: #fff;
}
.form-section {
  padding: 0;
}
.warehouse-section{
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.warehouse-label {
  font-size: 34px;
  color: #495057;
  margin-bottom: 28px;
  span{
    display: inline-block;
    margin-right: 18px;
    width: 10px;
    height: 38px;
    background: #e62d2d;
    vertical-align: middle;
    margin-top: -4px;
  }
}
.warehouse-label-tit{
  display: flex;
  font-size: 28px;
  color: #495057;
  align-items: center;
  width: 25%;
}
.warehouse-clo{
  display: flex;
  flex-direction: row;
  .sub-btn{
    display: flex;
    flex: 1;
    justify-content: flex-end;
    align-items: center;
    .clo-btn{
      display: flex;
      height: 70px;
      line-height: 70px;
      border-radius: 10px;
      border:2px solid #e62d2d;
      color: #e62d2d;
      padding: 0 40px;
    }
  }
}
.form-item .van-cell{
  border: 2px solid #e9e9e9;
}
.modal-options{
  padding: 0 30px;
  display: flex;
  flex-wrap: wrap;
}
.modal-option{
  background-color: #f5f5f5;
  border-radius: 35px;
  padding: 5px 35px;
  margin-right: 25px;
  margin-bottom: 20px;
  color: #666;
  border: 2px solid #8f8f8f;
}
.active{
  background-color: #e62d2d;
  border: 2px solid #e62d2d;
  color: white;
}


.supply-item {
  background: white;
  //border: 2px solid #e17055;
  border-radius: 12px;
  margin-bottom: 15px;
  overflow: hidden;
  transition: all 0.3s ease;
  padding: 20px;
  //box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.supply-item:hover {
  border-color: #e17055;
  box-shadow: 0 4px 12px rgba(225, 112, 85, 0.1);
}

.supply-header {
  padding:10px 20px 20px;
  display: flex;
  justify-content: space-between;
  //background: linear-gradient(135deg, #fff5f3 0%, #fef5f3 100%);
}

.supply-name {
  display: flex;
  width: 100%;
  font-size: 38px;
  color: #2d3436;
  justify-content: center;
  margin-bottom: 10px;
}
.supply-btn{
  font-size: 42px;
  font-weight: 600;
  color: #aaaaaa;
}
.supply-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;

}

.quantity-section {
  background: white;
  padding:0 20px;
  //border-top: 1px solid #f1f3f4;
}

.quantity-input {
  display: flex;
  flex-direction: column;
  //align-items: center;
  margin-bottom: 25px;
}

.quantity-label {
  font-size: 28px;
  color: #495057;
  margin-right: 15px;
  margin-bottom: 25px;
  min-width: 80px;
  font-weight: 500;
}

.quantity-controls {
  display: flex;
  width: 100%;
  //box-shadow: 0 2px 8px rgba(10,10,10,0.3);
  border: 2px solid #e9ecef;
  border-radius: 10px;
  //overflow: hidden;
  //opacity: 0.5;
}

.quantity-btn {
  background: #e62d2d;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: not-allowed;
  padding: 20px 40px;
  margin: 10px 20px;
  color: #fff;
  font-weight: 600;
  border-radius: 10px;
}

.quantity-input input {
  border: none;
  width: 170px;
  height: 45px;
  text-align: center;
  background: #f8f9fa;
  font-weight: 600;
  color: #6c757d;
  cursor: not-allowed;
}
.application-content {
  padding: 20px;
}

.application-item {
  background: white;
  border-radius: 12px;
  padding: 28px;
  margin-bottom: 15px;
  //border-left: 4px solid #00b894;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
  display: flex;
  justify-content: space-between;
  //align-items: center;
}

.application-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

/* --- ADDED --- */
.application-info-wrapper {
  margin-right: 15px;
}

.application-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px; /* MODIFIED */
}

.application-id {
  font-size: 28px;
  color: #495057;
  font-weight: 600;
}

.application-details {
  /* --- MODIFICATION START --- */
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 8px 20px; /* row-gap column-gap */
  /* --- MODIFICATION END --- */
  color: #6c757d;
  line-height: 1.6;
  margin-bottom: 0; /* MODIFIED */
}

.detail-item {
  display: flex;
  /* --- REMOVED justify-content: space-between; --- */
  gap: 5px; /* ADDED */
}

.box-detail-label {
  color: #6c757d;
}

.detail-value {
  color: #2d3436;
  font-weight: 600;
}

.quantity-highlight {
  color: #e17055;
  font-weight: 700;
  font-size: 28px;
}

.network-code {
  color: #0984e3;
  font-family: 'Monaco', 'Consolas', monospace;
}

.action-buttons {
  text-align: right;
  flex-shrink: 0;
}
.record-time{
  color: #6c757d;
  background: #f8f9fa;
  padding: 8px 20px;
  border-radius: 22px;
}
.action-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.outbound-btn {
  background: linear-gradient(135deg, #e17055 0%, #d63031 100%);
  color: white;
}

.outbound-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(225, 112, 85, 0.3);
}

.outbound-btn:disabled {
  background: #bbb;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
.group-video {
  border-radius: 8px;
  position: relative;
  .group-video-load {
    position: relative;
    border-radius: 10px;
    height: 100%;
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: row;

    .van-image {
      display: flex;
      max-width: 240px;
      height: 180px;
      border-radius: 8px;
      margin-right: 20px;

      /deep/ .van-image__img {
        display: flex;
        max-width: 240px;
        max-height: 170px;
        border-radius: 8px;
      }
    }

    .image-box {
      max-width: 240px;
      height: 180px;
      border-radius: 8px;
      margin-right: 20px;

      img {
        display: flex;
        max-width: 240px;
        max-height: 170px;
        border-radius: 8px;
      }
    }

    .avatar-uploader {
      display: flex;
      width: 100%;
      height: 100%;
      align-items: center;
      overflow: hidden;

      .el-upload {
        width: 100%;
        height: 100%;
      }
    }
  }
}

/deep/ .el-upload-list--picture-card .el-progress {
  width: 100%;

  /deep/ .el-progress__text {
    text-align: center;
  }
}

/deep/ .el-progress-circle {
  width: 130px !important;
  height: 130px !important;
  margin: 0 auto;
}
.form-buttons-btm{
  margin-top: 30px;
  .van-button{
    background: #e62d2d;
    color: #fff;
    border: none;
    border-radius: 10px;
  }
}
.time-size{
  padding-top: 10px;
  font-size: 25px;
}
</style>